<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->
<template>
  <div class="error-container">
    <div class="error-page">
      <div class="error-logo-section">
        <img
          src="@/assets/logo/logo-pristy-square.svg"
          alt="Pristy logo"
          class="pristy-logo"
        />
      </div>
      <div class="error-content-section">
        <div class="error-content">
          <div class="error-message">
            <h1 v-if="id" class="error-title">
              {{ $t("error", { error: id }) }}
            </h1>
            <span class="error-description">{{ $t(`errors.${id}`) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ErrorPage",
  data() {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = this.$route.params.id;
  },
};
</script>
<style scoped lang="scss">
.error-container {
  background: var(--p-surface-ground);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-width: 100vw;
  overflow: hidden;
}

.error-page {
  display: grid;
  justify-content: center;
  padding: 1.5rem;
  min-width: 80%;
}

.error-logo-section {
  width: 100%;
  margin-top: 1.25rem;
  text-align: center;

  @media (min-width: 1280px) {
    margin-top: 0;
  }
}

.pristy-logo {
  width: 400px;
  height: 350px;
  margin-bottom: 1.25rem;
}

.error-content-section {
  width: 100%;

  @media (min-width: 1280px) {
    width: 50%;
  }
}

.error-content {
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 1.75rem 1rem;
}

.error-message {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.error-title {
  color: var(--p-text-color);
  font-weight: bold;
  font-size: 1.875rem;
  margin-bottom: 0.5rem;

  @media (min-width: 1024px) {
    font-size: 3rem;
  }
}

.error-description {
  color: var(--p-text-muted-color);
}
</style>
